import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    integrationProviders: []
  },
  mutations: {
    SET_INTEGRATION_PROVIDERS (store, items) {
      store.integrationProviders = items
    }
  },
  getters: {
    getIntegrationProviders: (store, getters) => {
      return store.integrationProviders
    }
  },
  actions: {
    /*
    selectIntegrationProviders
    */
    selectIntegrationProviders ({commit, dispatch, getters, state}, filters) {
      return dispatch('getIntegrationProviders', filters).then((response) => {
        commit('SET_INTEGRATION_PROVIDERS', response)
        return response
      })
    },
    /*
    getIntegrationProviders
    */
    getIntegrationProviders ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/integrations-providers`, {params: filters})
      .then((response) => {
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/integrations.js